<template>
    <component :is="tag" :class="className" v-if="hasGeometry">
        <i class="fas fa-map-marked-alt action view-on-map"
            data-toggle="tooltip-city"
            data-placement="left"
            :title="$t(`${title}`)"
            @click.prevent="onViewGeometry" />
    </component>
</template>
<script>
import { isArray, isJson } from '@config/utils';

export default {
    props: {
        tag: {
            type: String,
            default: 'li',
        },
        className: {
            type: String,
            default: 'list-group-item',
        },
        title: {
            type: String,
            required: false,
            default: 'global.view-on-map'
        },
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        geometry() {
            let data = this.value || {};
            let geometry = data?.geojson ?? data?.geom ?? data?.position ?? data?.areas;
            return geometry ? (isArray(geometry) ? (geometry.length ? geometry : null) : (isJson(geometry) ? geometry : null)) : null;
        },
        hasGeometry() {
            return !!this.geometry;
        },
    },
    methods: {
        onViewGeometry: function() {
            if(this.hasGeometry){
                this.$emit('view', {geometry: this.geometry, geomProperty: 'geometry', ...this.value});
            }
        },
    }
}
</script>